export default "__VITE_ASSET__Buv91hHe__"